export const BUTTONS_ANIMATION_STYLE_LEFT = -228;
export const BUTTONS_INITIAL_STYLE_LEFT = 0;
export const BUTTONS_ANIMATION_TIME = 150;
